import { Card, Col, Row } from "reactstrap";
import { BreckPointSpecificTitle } from "../../../../../constants";
import { BreckPointSpecificSubTitle, BreckPointSpecificBody, BreckPointSpecificHead } from "../../../../../data/formsAndTable/tables/reactstrapTables/BasicTables";
import CommonTable from "./common/CommonTable";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const BreckpointSpecific = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BreckPointSpecificTitle} span={BreckPointSpecificSubTitle} headClass="pb-20" tag />
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <div className="table-responsive custom-scrollbar">
              <CommonTable size="sm" headData={BreckPointSpecificHead}>
                {BreckPointSpecificBody.map((data) => (
                  <tr key={data.id}>
                    <th scope="row">{data.id}</th>
                    <td>{data.name}</td>
                    <td>{data.orderId}</td>
                    <td>{data.price}</td>
                    <td>{data.quantity}</td>
                    <td>{data.total}</td>
                  </tr>
                ))}
              </CommonTable>
            </div>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
export default BreckpointSpecific;
